<template>
    <div v-if="permissionsShow">
        <el-checkbox :indeterminate="currentIndeterminate" v-model="currentCheckAll" @change="_handleCheckAllChange" v-show="hascheckAll">{{ $t('component.CHECK_ALL') }}</el-checkbox>
        <!-- <div style="margin: 15px 0;" v-show="hascheckAll"></div> -->
        <el-checkbox-group v-model="currentValue" :disabled="disabled" :size="size" :min="min" :max="max" :text-color="textColor" :fill="fill" @change="_handleCheckedChange">
            <div v-if="hasBtn">
                <el-checkbox-button
                    v-for="checkd in allList"
                    :class="checkboxClass"
                    :style="checkboxStyle"
                    :label="hasBasicTypes ? checkd : checkd[keys]"
                    :key="hasBasicTypes ? checkd : checkd[keys]"
                    :border="border"
                    :indeterminate="checkd.isIndeterminate === undefined ? false : checkd.isIndeterminate"
                >
                    <div v-if="overLenghOmission" :style="{ width: labelWidth + 'px' }" :title="hasBasicTypes ? checkd : $t(checkd[text])">
                        {{ hasBasicTypes ? checkd : $t(checkd[text]) }}
                    </div>
                    <span v-else>{{ hasBasicTypes ? checkd : $t(checkd[text]) }}</span>
                </el-checkbox-button>
            </div>
            <div v-else>
                <el-checkbox
                    v-for="checkd in allList"
                    :class="checkboxClass"
                    :style="checkboxStyle"
                    :label="hasBasicTypes ? checkd : checkd[keys]"
                    :key="hasBasicTypes ? checkd : checkd[keys]"
                    :border="border"
                    :indeterminate="checkd.isIndeterminate === undefined ? false : checkd.isIndeterminate"
                >
                    <div v-if="overLenghOmission" :style="{ width: labelWidth + 'px' }" :title="hasBasicTypes ? checkd : $t(checkd[text])">
                        {{ hasBasicTypes ? checkd : $t(checkd[text]) }}
                    </div>
                    <span v-else>{{ hasBasicTypes ? checkd : $t(checkd[text]) }}</span>
                </el-checkbox>
            </div>
        </el-checkbox-group>
    </div>
</template>
<script>
export default {
    created() {
        /* 权限数据处理 */
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
        }
        if (this.$util.isArray(this.value)) {
            this.currentValue = this.value;
        } else if (this.value != '') {
            this.currentValue = JSON.parse(this.value);
        }
        this.currentCheckAll = this.value.length === this.allList.length;
        this.currentIndeterminate = this.value.length > 0 && this.value.length < this.allList.length;
    },
    props: {
        /* 所有需要创建的check数组 */
        allList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 选中的check数组 */
        value: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* id值关键字 */
        keys: {
            type: String,
            default: function() {
                return 'value';
            }
        },
        /* 显示文字的关键字 */
        text: {
            type: String,
            default: function() {
                return 'label';
            }
        },
        /* 是否全选 */
        checkAll: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 边框 */
        border: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 显示全选 */
        hascheckAll: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 是否显示button类型按钮 */
        hasBtn: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 是否为基本类型的数据，例如['A','B']形式 */
        hasBasicTypes: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 多选框组尺寸，仅对按钮形式的 Checkbox 或带有边框的 Checkbox 有效 */
        size: String,
        /* 可被勾选的 checkbox 的最小数量 */
        min: Number,
        /* 可被勾选的 checkbox 的最大数量 */
        max: Number,
        /* 按钮形式的 Checkbox 激活时的填充色和边框色 #409EFF*/
        fill: String,
        /* 按钮形式的 Checkbox 激活时的文本颜色 #ffffff */
        textColor: String,
        /* 样式修改 */
        checkboxClass: {
            type: String
        },
        checkboxStyle: {
            type: String
        },
        /* 是否超出长度以...代替 */
        overLenghOmission: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 文字框宽度，超出部分显示... */
        labelWidth: {
            type: Number,
            default: function() {
                return 150;
            }
        },
        disabled: Boolean,
        indeterminate: Boolean,
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },

    data() {
        return {
            /* 是否满足显示权限 */
            permissionsShow: true,
            currentValue: [],
            currentIndeterminate: this.indeterminate,
            currentCheckAll: this.checkAll
        };
    },
    watch: {
        /* 监听数据的变化，实时生效 */
        allList: {
            handler: function(newVal) {
                this.allList = newVal;
                this.change();
            },
            deep: true
        },
        value: {
            handler: function(newVal) {
                this.currentValue = newVal;
                this.change();
                this.dispatch('ElFormItem', 'el.form.change', newVal);
            },
            deep: true
        }
    },
    methods: {
        dispatch(componentName, eventName, params) {
            var parent = this.$parent || this.$root;
            var name = parent.$options.componentName;

            while (parent && (!name || name !== componentName)) {
                parent = parent.$parent;

                if (parent) {
                    name = parent.$options.componentName;
                }
            }
            if (parent) {
                parent.$emit.apply(parent, [eventName].concat(params));
            }
        },
        change() {
            this.currentCheckAll = this.value.length === this.allList.length;
            this.currentIndeterminate = this.value.length > 0 && this.value.length < this.allList.length;
        },
        /* 全选时回调 */
        _handleCheckAllChange(val) {
            this.checkAllSet();
            this.currentIndeterminate = false;
            this.$emit('handleCheckAllChange', val);
        },
        /* 选中变化回调 */
        _handleCheckedChange(value) {
            /* 清楚isIndeterminate的选中状态 */
            this.allList.forEach(item => {
                if (item[this.keys] === value[value.length - 1] && item.isIndeterminate !== undefined) {
                    item.isIndeterminate = false;
                }
            });
            let checkedCount = value.length;
            this.currentCheckAll = checkedCount === this.allList.length;
            this.currentIndeterminate = checkedCount > 0 && checkedCount < this.allList.length;

            /* checkNewest 当前最新选中的对象 value为所有选中的对象 */
            let checkNewest = value[value.length - 1];
            this.$emit('handleCheckedChange', value, checkNewest);
            this.$emit('input', value);
        },
        /* 返回选中的数组 */
        getCheckList() {
            return this.currentValue;
        },
        /* 全选功能实现 */
        checkAllSet() {
            if (this.allList.length > this.currentValue.length) {
                for (let check of this.allList) {
                    if (!this.hasBasicTypes) {
                        let index = JSON.stringify(this.currentValue).indexOf(JSON.stringify(check[this.keys]));
                        if (index === -1) {
                            this.currentValue.push(check[this.keys]);
                        }
                    } else {
                        let index = JSON.stringify(this.currentValue).indexOf(JSON.stringify(check));
                        if (index === -1) {
                            this.currentValue.push(check);
                        }
                    }
                }
            } else {
                this.currentValue = [];
            }
        },
        /* 实现反选功能 */
        counterSelection() {
            let listCheck = [];
            for (let check of this.allList) {
                if (!this.hasBasicTypes) {
                    let index = JSON.stringify(this.currentValue).indexOf(JSON.stringify(check[this.keys]));
                    if (index === -1) {
                        listCheck.push(check[this.keys]);
                    }
                } else {
                    let index = JSON.stringify(this.currentValue).indexOf(JSON.stringify(check));
                    if (index === -1) {
                        listCheck.push(check);
                    }
                }
            }
            this.currentValue = listCheck;
        }
    }
};
</script>
<style>
.el-checkbox + .el-checkbox {
    margin-left: 0 !important;
}
.el-checkbox {
    margin-right: 25px;
}
.el-checkbox__label div {
    overflow: hidden;
    vertical-align: bottom;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
